import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';

function CallbackHandler() {
  const { handleCallback } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(null);
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    (async () => {
      try {
        const params = new URLSearchParams(location.search);
        const code = params.get('code');
        const state = params.get('state');
        if (!code || !state) throw new Error('缺少必要的認證參數');

        const user = await handleCallback(code, state);
        if (!user) throw new Error('取得使用者資料失敗');
        navigate('/', { replace: true });
      } catch (err) {
        console.error('處理登入回調時發生錯誤:', err);
        setError(err.message || '登入處理失敗，請稍後再試。');
      }
    })();
  }, [location, navigate, handleCallback]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      {error ? (
        <div style={{ color: '#e42313', textAlign: 'center' }}>
          <h2>登入失敗</h2>
          <p>{error}</p>
          <button onClick={() => navigate('/')}>返回首頁</button>
        </div>
      ) : (
        <div style={{ textAlign: 'center' }}>
          <h2>正在處理登入請求，請稍候...</h2>
          <div
            style={{
              border: '4px solid #333333',
              borderLeft: '4px solid #e42313',
              borderRadius: '50%',
              width: '30px',
              height: '30px',
              margin: '20px auto',
              animation: 'spin 1s linear infinite',
            }}
          />
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      )}
    </div>
  );
}

export default CallbackHandler;
